import React, {ChangeEvent, useEffect, useRef, useState} from "react";
import {Input} from "../../../ui-components/Input/Input";
import {ValidationErrorText} from "../../../ui-components/ValidationErrorText/ValidationErrorText";

interface CvvInputProps {
    cvv: string;
    onSetCvv: (cvv: string) => void;
    onSetCvvValid: (isCvvValid: boolean) => void;
    isCvvSelected: boolean;
}

export const CvvInput: React.FunctionComponent<CvvInputProps> = (props) => {
    const [errors, setErrors] = useState<string[]>([]);
    const [isValid, setIsValid] = useState<boolean>(true);
    const invalidCvvError = 'CVV filled in incorrect format.';
    const requiredCvvError = 'CVV is a required field.';
    const inputRef = useRef<HTMLTextAreaElement>() as any;

    useEffect(() => {
        if (props.isCvvSelected && inputRef.current) {
            (inputRef.current as HTMLInputElement).focus();
        }
    }, [props.isCvvSelected]);

    const onChange = (event: ChangeEvent) => {
        const cvv = (event.target as HTMLInputElement).value;
        props.onSetCvv(cvv);
        validateCvv(cvv);
    }

    const onBlur = (event: React.FocusEvent<HTMLInputElement>) => {
        validateCvv();
    }

    const validateCvv = (cvv: string = '') => {
        cvv = cvv || props.cvv;
        let errorsTemp: string[] = [];
        if (cvv.length !== 3 && cvv.length !== 4 || !Number.isFinite(parseFloat(cvv))) {
            errorsTemp.push(invalidCvvError);
        }
        if (cvv === '') {
            errorsTemp.push(requiredCvvError);
        }
        setErrors(errorsTemp);
        setIsValid(errorsTemp.length === 0);
        props.onSetCvvValid(isValid);
    }

    const onKeyUp = (event: React.KeyboardEvent<HTMLInputElement>) => {
        validateCvv();
    }

    return <div>
        <Input ref={inputRef} isValid={isValid} type='number' required={true} value={props.cvv} onChange={onChange}
               onBlur={onBlur} onKeyUp={onKeyUp}/>
        {errors.map((error: string) => {
            return <ValidationErrorText key={error} text={error}/>
        })}
    </div>
}
